import { requestResetPassword, confirmEmail, resetPassword, resetPasswordLanding } from '../../api/user'
import {
  REQUEST_RESET_PASSWORD,
  SET_REQUEST_RESET_PASSWORD_ERROR,
  RESET_REQUEST_RESET_PASSWORD_ERROR,
  CONFIRM_EMAIL,
  RESET_PASSWORD,
  RESET_PASSWORD_LANDING
} from './constant'
import { ActionTree } from 'vuex'
import { UserState } from './types'

import {
  Response,
  ConfirmEmailPayload,
  RequestResetPasswordPayload,
  ResetPasswordPayload
} from '../../api/type'
import { APP_MODULE, SET_IS_LOADING } from '../app/constant'

export const actions: ActionTree<UserState, any> = {
  async [REQUEST_RESET_PASSWORD]({ commit }, payload: RequestResetPasswordPayload) {
    try {
      commit(`${APP_MODULE}/${SET_IS_LOADING}`, true, { root: true })
      const resp = await requestResetPassword(payload)
      const data = resp as Response
      return data
    } catch (e) {
      const serverErr = e as Response
      commit(SET_REQUEST_RESET_PASSWORD_ERROR, serverErr?.error_message)
      commit(`${APP_MODULE}/${SET_IS_LOADING}`, false, { root: true })
      return
    }
  },
  [RESET_REQUEST_RESET_PASSWORD_ERROR]({ commit }) {
    commit(SET_REQUEST_RESET_PASSWORD_ERROR, false)
  },
  [CONFIRM_EMAIL]({ commit }, payload: ConfirmEmailPayload) {
    commit(`${APP_MODULE}/${SET_IS_LOADING}`, true, { root: true })
    confirmEmail(payload)
      .then(() => {
        // tell me what to do.
      })
      .catch(() => {
        location.replace(process.env.VUE_APP_FINNO_ENDPOINT)
      })
      .finally(() => {
        commit(`${APP_MODULE}/${SET_IS_LOADING}`, false, { root: true })
      })
  },
  async [RESET_PASSWORD]({ commit }, payload: ResetPasswordPayload) {
    try {
      commit(`${APP_MODULE}/${SET_IS_LOADING}`, true, { root: true })
      const resp = await resetPassword(payload)
      commit(`${APP_MODULE}/${SET_IS_LOADING}`, false, { root: true })
      return resp
    } catch (ex) {
      commit(`${APP_MODULE}/${SET_IS_LOADING}`, false, { root: true })
      return ex
    }
  },
  async [RESET_PASSWORD_LANDING](_, payload: ResetPasswordPayload) {
    try {
      const resp = await resetPasswordLanding(payload)
      return resp
    } catch (ex) {
      return ex
    }
  }
}
